import { JSX } from 'react';

import { KeyboardArrowRight } from '@videoblocks/react-icons';

const FolderShowAllButton = ({
    showAllButton = true,
    openFoldersInNewWindow = false,
}: {
    showAllButton?: boolean;
    openFoldersInNewWindow?: boolean;
}): JSX.Element => {
    return (
        <>
            {showAllButton && (
                <div className="w-full pt-4 pb-1 m-auto mb-0 text-sm font-bold text-center border-0 border-t border-gray-400 border-solid">
                    <a
                        className="hover:text-blue-600 m-0 text-blue-500 no-underline"
                        href={'/member/folders'}
                        target={openFoldersInNewWindow ? '_blank' : '_self'}
                    >
                        View All Folders
                        <KeyboardArrowRight className="w-4 h-4 inline-block ml-2 fill-current" />
                    </a>
                </div>
            )}
        </>
    );
};

export default FolderShowAllButton;
